export const RETURN_POLICY_VALIDATION = {
    title: {
        required: 'Title wajib diisi',
    },
    description: {
        required: 'Description wajib diisi',
    },
}
